module.exports = __webpack_public_path__ + "img/006-pros-and-cons.c3cd5fd8.svg";